/**
 * Convert a data: url to a Blob object
 *
 * See: https://stackoverflow.com/a/67551175
 * @param dataUrl
 * @returns Blob
 */
export const dataUrlToBlob = (dataUrl: string) => {
  const [header, body] = dataUrl.split(",");
  const mime = header.match(/:(.*?);/)?.[1];

  const bytes = atob(body);
  const u8arr = new Uint8Array(bytes.length);

  for (let i = 0; i < bytes.length; i++) {
    u8arr[i] = bytes.charCodeAt(i);
  }

  return new Blob([u8arr], { type: mime });
};
